import { reactive, type Ref, type UnwrapNestedRefs } from 'vue';
import { getSensorDataOfMovieList } from 'src/lib/moviePlayerHelper';
import type { IMovieMetaInfoArea } from 'src/models';
import type { LeftRight, MoviePlayerCompareModeState } from 'src/models/moviePlayer';

interface Deps {
  refMetaInfoAreaLeft: Ref<IMovieMetaInfoArea | undefined>;
  refMetaInfoAreaRight: Ref<IMovieMetaInfoArea | undefined>;
}

interface MoviePlayerCompareModeSensorContext {
  getCurrentMovieListSensorData: (lr: LeftRight) => Promise<void>;
}

export function useMoviePlayerCompareModeSensor(
  state: UnwrapNestedRefs<MoviePlayerCompareModeState>,
  deps: Deps,
): UnwrapNestedRefs<MoviePlayerCompareModeSensorContext> {
  const getCurrentMovieListSensorData = async(lr: LeftRight) => {
    const ml = state[lr].movieList.listSelection.currentMovieList;
    if (!ml) return;

    const sensorData = await getSensorDataOfMovieList(ml);
    const metaInfoArea = lr === 'left' ? deps.refMetaInfoAreaLeft.value : deps.refMetaInfoAreaRight.value;
    if (metaInfoArea) {
      metaInfoArea.setSensorData(sensorData);
    }
  };

  return reactive({ getCurrentMovieListSensorData });
}
